import { Button } from '~/components/button'
import { useInputTextContext } from '../../input-text'
import type {
  InputTextClearButtonProps,
  InputTextScopedProps,
} from '../../input-text.types'
import {
  inputTextClearButtonContainerVariants,
  inputTextClearButtonVariants,
} from './index.styles'

export const InputTextClearButton = ({
  __scopeInputText,
  ...props
}: InputTextScopedProps<InputTextClearButtonProps>) => {
  const { size, disabled, readOnly, isActive } = useInputTextContext(
    'InputTextClearButton',
    __scopeInputText
  )

  return (
    <div
      className={inputTextClearButtonContainerVariants({
        size,
        disabled,
        readOnly,
        isActive,
      })}
      aria-disabled={disabled || readOnly}
    >
      <Button.Root
        {...props}
        size={size}
        disabled={disabled || readOnly}
        variant="neutral-tertiary"
        className={inputTextClearButtonVariants({ size })}
      >
        <Button.Icon symbol="rdicon-dismiss-circle-outline" />
      </Button.Root>
    </div>
  )
}
